<div class="form-content-item">
  <h2 class="page-title">{{ 'dredging_info_page_title' | translate }}</h2>
  <div class="info-panel">
    <mat-card>
      <div class="info-header">
        <mat-icon>info_outline</mat-icon>
        <h3>{{ 'equipment_info_title' | translate }}</h3>
      </div>
      <div class="info-content">
        <p>{{ 'dredging_info_parameters' | translate }}</p>
        <p>{{ 'dredging_info_scope' | translate }}</p>
      </div>
    </mat-card>
  </div>
</div>
